module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter_fm1",
    attrs: {
      "id": "c12"
    }
  }, [_c('span', {
    staticClass: "chapter_fm1"
  }, [_vm._v("c. 200")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter01"
  }, [_vm._v("Porcelain")]), _vm._v(" "), _c('p', {
    staticClass: "seealso_fm2"
  }, [_c('strong', [_vm._v("Ehrenfried Walther von Tschirnhaus")]), _vm._v(" (1651–1708), "), _c('strong', [_vm._v("Johann Friedrich Böttger")]), _vm._v(" (1682–1719)")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Proto-porcelain had been produced in China a couple thousand years prior, but true porcelain doesn’t appear on the archaeological record until the late Han dynasty period, which ended around 220. During the Sui and Tang dynasties (581–907), porcelain was created on a much larger scale. Durable and beautiful ceramics became a valuable export, first to the Islamic world and then, after 1300, to Europe. The remarkable thing is that during this whole period, no one else in the world could produce it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ceramics are an extraordinarily ancient art in China, with early examples possibly going back twenty thousand years. Porcelain was probably discovered, gradually, by craftsmen pushing the techniques of pottery-making further in search of new wares to sell. Its composition varies, but a good source of kaolin clay—which takes its name from a village in southwest China—is needed. Other ingredients include ground glass and minerals such as feldspar or alabaster, quartz, and bone ash. Two key factors in porcelain production are the amount of water in the mixture, which has to be kept within narrow limits, and the high firing temperatures (over 1200°C, or 2100°F), which allow for the formation of glassy phases in the final ceramic that are mixed with fine needles of the aluminosilicate mineral mullite.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Countless attempts were made to reproduce the Chinese techniques, but the first success occurred in Saxony (now part of Germany). A self-styled alchemist named Johann Friedrich Böttger had brought enough attention to himself by 1704 that Augustus the Strong (elector of Saxony and king of Poland) imprisoned him in Dresden in hopes of forcing him to produce gold. The German physicist-physician-philosopher Ehrenfried Walther von Tschirnhaus, who had been trying to make porcelain as another revenue stream for Augustus, was put in charge of Böttger, and after they were shipped samples of kaolin clay and alabaster in 1708, the breakthrough occurred. Von Tschirnhaus died suddenly that year, and Böttger, now free, was put in charge of the new porcelain factory in Meissen in 1710. Just two years later, a Jesuit priest revealed the Chinese methods his order had witnessed, and porcelain manufacture spread rapidly throughout Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "seealso"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c11"
    }
  }, [_vm._v("Roman Concrete (c. 126)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "dis_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/037.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("This eighteenth-century Chinese porcelain figurine of the Buddhist deity Guanyin, goddess of mercy, now resides in the Hallwyl Museum in Sweden.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70128a57","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c12.vue
// module id = 111
// module chunks = 0